// extracted by mini-css-extract-plugin
module.exports = {"slider_card":"SliderCard_slider_card__uczxJ","slider_drag":"SliderCard_slider_drag__Lk_CG","slider_card_drag":"SliderCard_slider_card_drag__MsyBj"};